import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import purchaseResaleReducer from '@/features/private-resale/purchase-resale/purchaseResaleSlice';
import salesProceedReducer from '@/features/private-resale/sales-proceed/salesProceedSlice';
import buyerStampDutyReducer from '@/features/private-resale/buyer-stamp-duty/buyerStampDutySlice';
import rentalYieldReducer from '@/features/rental-yield/rentalYieldSlice';
import tdsrReducer from '@/features/private-resale/tdsr/tdsrSlice';
import ciPurchaseReducer from '@/features/commercial-industrial/purchase-resale/purchaseResaleSlice';
import ciSalesProceedsReducer from '@/features/commercial-industrial/sales-proceeds/salesProceedsSlice';
import ciResaleVsBucReducer from '@/features/commercial-industrial/resale-vs-buc/resaleVsBucSlice';
import ciInvestmentReducer from '@/features/commercial-industrial/investment/investmentSlice';
import othersMortgageLoanReducer from '@/features/others/mortgage-loan/mortgageLoanSlice';
import othersPartSharePurchaseReducer from '@/features/others/part-share-purchase/partSharePurchaseSlice';
import othersEquityTermLoanReducer from '@/features/others/equity-term-loan/equityTermLoanSlice';
import othersRentalStampDutyReducer from '@/features/others/rental-stamp-duty/rentalStampDutySlice';
import othersPledgeUnpledgeReducer from '@/features/others/pledge-unpledge/pledgeUnpledgeSlice';
import othersCpfUsageReducer from '@/features/others/cpf-usage/cpfUsageSlice';
import hdbSalesProceedsReducer from '@/features/hdb-resale/sales-proceeds/salesProceedsSlice';
import msrReducer from '@/features/hdb-resale/msr/msrSlice';
import hdbResalePurchase from '@/features/hdb-resale/purchase/purchaseSlice';
import purchaseNewProjectReducer from '@/features/private-resale/purchase-new-project/purchaseNewProjectSlice';

const rootReducers = combineReducers({
  resale: purchaseResaleReducer,
  salesProceed: salesProceedReducer,
  bsd: buyerStampDutyReducer,
  rentalYield: rentalYieldReducer,
  tdsr: tdsrReducer,
  purchaseNewProject: purchaseNewProjectReducer,
  ciPurchase: ciPurchaseReducer,
  ciSalesProceeds: ciSalesProceedsReducer,
  ciResaleVsBuc: ciResaleVsBucReducer,
  ciInvestment: ciInvestmentReducer,
  othersMortgageLoan: othersMortgageLoanReducer,
  otherPartSharePurchase: othersPartSharePurchaseReducer,
  othersEquityTermLoan: othersEquityTermLoanReducer,
  othersRentalStampDuty: othersRentalStampDutyReducer,
  othersPledgeUnpledge: othersPledgeUnpledgeReducer,
  othersCpfUsage: othersCpfUsageReducer,
  hdbSalesProceeds: hdbSalesProceedsReducer,
  msr: msrReducer,
  hdbResalePurchase,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [],
  blacklist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: import.meta.env.VITE_NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
